import {Injectable, inject} from '@angular/core';

import {Observable, of} from 'rxjs';

import {Action} from '@actions/action';
import {LessonGenerationStore} from '@stores/lesson-generation.store';
import {RouteStore} from '@stores/route.store';

/** Opens a lesson built from a PDF and closes its snackbar. */
@Injectable({providedIn: 'root'})
export class OpenGeneratedLessonAction implements Action<string, void> {
  private readonly _lessonGenerationStore = inject(LessonGenerationStore);
  private readonly _routeStore = inject(RouteStore);

  /** @param jobId the job that built the lesson */
  execute(jobId: string): Observable<void> {
    const lesson = this._lessonGenerationStore
      .state()
      .find((j) => j.id === jobId)?.lesson;
    if (lesson) {
      this._lessonGenerationStore.remove(jobId);
      // No `ts` (it marks a lesson just created, which opens the add-card toolbar) and no
      // `eventId` (the lesson page then fetches its sections)
      this._routeStore.lesson(lesson.mId, lesson.sK, {
        ref: this._routeStore.state().url,
      });
    }
    return of(void 0);
  }
}
